import axios from "axios";
import {useModal, useToast} from "@/comn/hooks";
import { useNavigate } from "react-router-dom";
import {useState} from "react";
import Cookies from "js-cookie";

export const useFindPassword = () => {
    const modal         = useModal();
    const navigate      = useNavigate();
    const { showToast } = useToast();

    const [ findPasswordForm, setFindPasswordForm ] = useState({ usrId : "", usrEmlAddr : "", isLcm: false });

    const handleSubmitFindPassword = async (event: any) => {
        event.preventDefault();

        const { usrId, usrEmlAddr, isLcm } = findPasswordForm;

        try {

            const caseMap: any = {
                  tancis    : { url: "/api/v1/ptli/mypage/myinfo/findpwd"             , payload: { usrDmnId       : usrId, usrEmlAddr}}
                , tanesw    : { url: "/api/v1/ptle/extptl/mypage/myinfochg/findpwd"   , payload: { xtrnUsrIdntfNo : usrId, usrEmlAddr}}
                , taneswLCM : { url: "/api/v1/ptle/extptl/mypage/myinfochg/findLcmPwd", payload: { coTin          : usrId, usrEmlAddr}}
            }

            const key      = ( process.env.REACT_APP_SYSTEM_GROUP == "tanoga" ? "tanesw" : process.env.REACT_APP_SYSTEM_GROUP ) + (isLcm ? "LCM" : "");
            const base     = process.env.REACT_APP_SYSTEM_GROUP == "tancis" ? process.env.REACT_APP_API_PTLI : process.env.REACT_APP_API_PTLE;
            const response = await axios.post( base + caseMap[key].url, caseMap[key].payload, { headers: { "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN" } } );

            response.status == 201 &&
            modal.openModal({ content: "A temporary password has been sent.",  onClose: () => {
                  process.env.REACT_APP_SYSTEM_GROUP == "tanesw" ? navigate("/ptle") : navigate("/login");
            }});

        } catch (error:any) {
            console.log(error);
            showToast({ content: error.response?.data?.errorMessage || "error", type: "error" });
        }
    };

    return { findPasswordForm, setFindPasswordForm, handleSubmitFindPassword };
};
